import AddCountry from "../pages/country/addCountry";
import CountryIndex from "../pages/country/country";
import EditCountry from "../pages/country/editCountry";

const countryRoutes = [
  {
    path: "country",
    element: <CountryIndex />,
  },
  {
    path: "country/add",
    element: <AddCountry />,
  },
  {
    path: "country/edit/:id",
    element: <EditCountry />,
  },
];

export default countryRoutes;